export default "__VITE_ASSET__836c089a__"